import React from 'react'
import Icon from './icon';

/**
 * @param text: String?
 * @param checked: Boolean
 * @param onChange: function(checked: Boolean)
 * @param disabled: Boolean = false
 */
class Checkbox extends React.Component
{

    render()
    {
        const checked = this.props.checked
        
        const label = this.props.text ? (
            <div className="label">{ this.props.text }</div>
        ) : null;

        return (
            <div
                style={ this.props.style }
                onClick={ () => {
                    if (!this.props.disabled) {  this.props.onChange(!checked) }
                } }
                className={ "dk-checkbox " + (checked ? "checked " : "") + (this.props.disabled ? "disabled " : "") }>
                <div className="box">
                    <div className={ "check " + (checked ? "checked" : "") } />
                </div>
                { label }
            </div>
        )
    }

}

export { Checkbox }
export default Checkbox